import type { CustomTheme, Theme } from '@moussenaires/shared';

import { api } from './client.js';

export interface PublicSettings {
  siteTitle: string;
  publicRoster: boolean;
  /** The theme every visitor without a personal preference of their own sees — the guild's own branding. */
  defaultTheme: Theme;
  defaultThemeCustom: CustomTheme | null;
}

export const publicSettingsApi = {
  get: () => api.get<PublicSettings>('/settings'),
};
